interface CompanyConfigProps {
  data: any;
  onChange: (updates: any) => void;
}

export function CompanyConfig({ data, onChange }: CompanyConfigProps) {
  const requireCompany = !!data.requireCompanyName;
  const companyLabel = data.companyFieldLabel || 'Entreprise';

  const requireCompanyInfo = !!data.requireCompanyInfo;
  const requireCompanyPhone = !!data.requireCompanyPhone;
  const requireCompanyEmail = !!data.requireCompanyEmail;
  const requireCompanyWebsite = !!data.requireCompanyWebsite;
  const companyPhoneLabel = data.companyPhoneLabel || 'Téléphone';
  const companyEmailLabel = data.companyEmailLabel || 'Email';
  const companyWebsiteLabel = data.companyWebsiteLabel || 'Site web';

  const setRequireCompany = (req: boolean) => {
    if (!req) {
      onChange({
        requireCompanyName: false,
        requireCompanyInfo: false,
        requireCompanyPhone: false,
        requireCompanyEmail: false,
        requireCompanyWebsite: false,
      });
    } else {
      onChange({ requireCompanyName: true });
    }
  };

  return (
    <div>
      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '1rem',
          padding: '1.25rem',
          background: requireCompany ? 'rgba(0,117,141,0.05)' : 'white',
          border: `2px solid ${requireCompany ? '#00758d' : '#e5e7eb'}`,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          if (!requireCompany) {
            e.currentTarget.style.borderColor = '#dfc32f';
            e.currentTarget.style.background = 'rgba(223,195,47,0.02)';
          }
        }}
        onMouseLeave={(e) => {
          if (!requireCompany) {
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.background = 'white';
          }
        }}
      >
        <input
          type="checkbox"
          checked={requireCompany}
          onChange={(e) => setRequireCompany(e.target.checked)}
          style={{
            width: '20px',
            height: '20px',
            marginTop: '2px',
            cursor: 'pointer',
            accentColor: '#00758d',
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#00303c',
              marginBottom: '0.25rem',
            }}
          >
            Demander l'entreprise / organisation
          </div>
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            Si activé, une section complète sera ajoutée pour collecter les informations de l'entreprise
          </div>
        </div>
      </label>

      {requireCompany && (
        <div
          style={{
            marginTop: '1.5rem',
            marginLeft: '3rem',
            padding: '1.5rem',
            background: 'linear-gradient(135deg, rgba(142,11,86,0.03) 0%, rgba(142,11,86,0.01) 100%)',
            border: '2px solid rgba(142,11,86,0.15)',
            borderRadius: '12px',
            animation: 'fadeIn 0.3s ease',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
            <CompanyIcon />
            <div>
              <h4 style={{ fontSize: '1rem', fontWeight: 700, color: '#4a042c', margin: 0 }}>Informations Entreprise</h4>
              <p style={{ fontSize: '0.85rem', color: '#666', margin: 0 }}>Détails de la personne morale</p>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem',
              padding: '1.5rem',
              background: 'white',
              borderRadius: '10px',
              border: '2px solid #f0f0f0',
            }}
          >
            <div>
              <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>
                Nom de la personne morale <span style={{ color: '#8E0B56' }}>*</span>
              </label>
              <input
                type="text"
                value={companyLabel}
                onChange={(e) => onChange({ companyFieldLabel: e.target.value })}
                placeholder="Ex: Entreprise, Organisation, Société..."
                style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.9rem', border: '2px solid #e5e7eb', borderRadius: '10px', outline: 'none' }}
              />
              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>Label du champ qui sera affiché dans le formulaire</p>
            </div>

            <div style={{ height: '1px', background: 'linear-gradient(90deg, transparent 0%, #e5e7eb 50%, transparent 100%)', margin: '0.5rem 0' }} />

            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1rem',
                background: requireCompanyInfo ? 'rgba(0,117,141,0.05)' : '#f8fafb',
                border: `2px solid ${requireCompanyInfo ? '#00758d' : '#e5e7eb'}`,
                borderRadius: '10px',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={requireCompanyInfo}
                onChange={(e) => onChange({ requireCompanyInfo: e.target.checked })}
                style={{ width: '20px', height: '20px', cursor: 'pointer', accentColor: '#00758d' }}
              />
              <div>
                <span style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c' }}>Demander les coordonnées de l'entreprise</span>
                <p style={{ fontSize: '0.85rem', color: '#666', margin: '0.25rem 0 0 0' }}>Téléphone, email et site web de l'organisation</p>
              </div>
            </label>

            {requireCompanyInfo && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', paddingLeft: '2rem', animation: 'fadeIn 0.3s ease' }}>
                <CompanySubField
                  label="Téléphone de l'entreprise"
                  checked={requireCompanyPhone}
                  onCheck={(v: boolean) => onChange({ requireCompanyPhone: v })}
                  inputValue={companyPhoneLabel}
                  onInputChange={(v: string) => onChange({ companyPhoneLabel: v })}
                />
                <CompanySubField
                  label="Email de l'entreprise"
                  checked={requireCompanyEmail}
                  onCheck={(v: boolean) => onChange({ requireCompanyEmail: v })}
                  inputValue={companyEmailLabel}
                  onInputChange={(v: string) => onChange({ companyEmailLabel: v })}
                />
                <CompanySubField
                  label="Site web (optionnel)"
                  checked={requireCompanyWebsite}
                  onCheck={(v: boolean) => onChange({ requireCompanyWebsite: v })}
                  inputValue={companyWebsiteLabel}
                  onInputChange={(v: string) => onChange({ companyWebsiteLabel: v })}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function CompanyIcon() {
  return (
    <div
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: 'linear-gradient(135deg, #8E0B56 0%, #4a042c 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    </div>
  );
}

interface CompanySubFieldProps {
  label: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
}

function CompanySubField({ label, checked, onCheck, inputValue, onInputChange }: CompanySubFieldProps) {
  return (
    <div>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
        <input type="checkbox" checked={checked} onChange={(e) => onCheck(e.target.checked)} style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#00758d' }} />
        <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#00303c' }}>
          {label} {checked && !label.includes('(optionnel)') && <span style={{ color: '#8E0B56' }}>*</span>}
        </span>
      </label>
      {checked && (
        <div style={{ marginLeft: '2rem' }}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder="Label du champ"
            style={{ width: '100%', maxWidth: '350px', padding: '0.75rem 1rem', fontSize: '0.9rem', border: '2px solid #e5e7eb', borderRadius: '10px', outline: 'none' }}
          />
        </div>
      )}
    </div>
  );
}
